import axios from 'axios'
import config from '../config/config'

/**
 * API Service
 *
 * Centralized API client using axios.
 * Configured with base URL and interceptors for auth and error handling.
 */

// Create axios instance with base configuration
const apiClient = axios.create({
  baseURL: config.apiBaseUrl,
  timeout: 120000, // 120 seconds — config caching (bug #030) should keep batches well under this
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor - add auth token to requests
apiClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage (if implementing authentication)
    // const token = localStorage.getItem('authToken')
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`
    // }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor - handle errors globally
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // Handle common error scenarios
    if (error.response) {
      // Server responded with error status
      switch (error.response.status) {
        case 401:
          // Unauthorized - redirect to login or refresh token
          console.error('Unauthorized access - please login')
          break
        case 403:
          // Forbidden
          console.error('Access forbidden')
          break
        case 404:
          // Not found
          console.error('Resource not found')
          break
        case 500:
          // Server error
          console.error('Internal server error')
          break
        default:
          console.error('An error occurred:', error.response.data)
      }
    } else if (error.request) {
      // Request made but no response received
      console.error('No response from server')
    } else {
      // Error in request configuration
      console.error('Error setting up request:', error.message)
    }

    return Promise.reject(error)
  }
)

// Example API functions (uncomment and modify as needed)

/**
 * Fetch user data
 * @returns {Promise} User data
 */
// export const getUser = async () => {
//   try {
//     const response = await apiClient.get('/api/user')
//     return response.data
//   } catch (error) {
//     throw error
//   }
// }

/**
 * Create a new item
 * @param {Object} data - Item data
 * @returns {Promise} Created item
 */
// export const createItem = async (data) => {
//   try {
//     const response = await apiClient.post('/api/items', data)
//     return response.data
//   } catch (error) {
//     throw error
//   }
// }

/**
 * Update an existing item
 * @param {string} id - Item ID
 * @param {Object} data - Updated data
 * @returns {Promise} Updated item
 */
// export const updateItem = async (id, data) => {
//   try {
//     const response = await apiClient.put(`/api/items/${id}`, data)
//     return response.data
//   } catch (error) {
//     throw error
//   }
// }

/**
 * Delete an item
 * @param {string} id - Item ID
 * @returns {Promise} Deletion confirmation
 */
// export const deleteItem = async (id) => {
//   try {
//     const response = await apiClient.delete(`/api/items/${id}`)
//     return response.data
//   } catch (error) {
//     throw error
//   }
// }

export default apiClient
